import React from "react";

import { Row, Col, Form, Spinner } from "react-bootstrap";
import Modal from "../../../../../layout/modal";
import ReportList, { BLANK_EMAIL_OPTION } from "../../../../../layout/select/report-list";
import TemplateCustomFieldInputs from "../../../../../layout/template-custom-fields/inputs";
import {
    getTemplateCustomFields,
    validateCustomValues
} from "../../../../../utils/template-custom-fields";

class ReportModal extends React.Component {
    /**
     *
     */
    constructor() {
        super();
        this.state = {
            items: [],
            selected: {
                target: {
                    name: "report",
                    value: BLANK_EMAIL_OPTION
                }
            },
            custom: {},
            customErrors: {},
            signatureRequest: false
        }
    }

    onOk = () => {
        if (this.props.working) return;

        const validation = validateCustomValues(this.customFields, this.state.custom);
        if (!validation.valid) {
            this.setState({ customErrors: validation.errors });
            return;
        }

        if (this.props.onOk) this.props.onOk({
            report: this.state.selected,
            custom: this.state.custom,
            signatureRequest: this.state.signatureRequest
        });
    }

    onCancel = () => {
        if (this.props.working) return;

        if (this.props.onCancel) this.props.onCancel();
    }

    onReportChange = (e) => {
        if (this.props.working) return;

        this.setState({ selected: e, custom: {}, customErrors: {}, signatureRequest: false });
    }

    onCustomChange = (name, value) => {
        if (this.props.working) return;

        this.setState(prev => ({
            custom: {
                ...prev.custom,
                [name]: value
            },
            customErrors: {
                ...prev.customErrors,
                [name]: undefined
            }
        }));
    }

    get customFields() {
        return getTemplateCustomFields(this.state.selected?.target?.value);
    }

    get canPrepareSignatureRequest() {
        const output = this.state.selected?.target?.value?.output;
        return ["RTF", "DXP"].includes(output);
    }

    render() {
        const canPrepareSignatureRequest = this.canPrepareSignatureRequest;
        const working = Boolean(this.props.working);
        const workingLabel = this.props.workingLabel || "Generating...";
        
        return (
            <>
                <Modal show={this.props.show} title="What Would You Like to Generate?" body="Pick the artifact you want to create." buttons={
                    [
                        {
                            caption: working ? "Working..." : "ok",
                            onEnabledClick: this.onOk,
                            variant: "primary",
                            enabled: !working,
                            display: true
                        },
                        {
                            default: true,
                            caption: "cancel",
                            onEnabledClick: this.onCancel,
                            variant: "primary",
                            enabled: !working,
                            display: true
                        }
                    ]
                }>
                    <Row className="g-0 sh-6 mb-2 mt-3">
                        <Col>
                            <div className="mb-3 top-label">
                                <ReportList
                                    items={this.props.items}
                                    selected={this.state.selected}
                                    onChange={this.onReportChange}
                                    isDisabled={working}
                                ></ReportList>
                                <Form.Label>DOCUMENT</Form.Label>
                            </div>
                                    
                        </Col>
                    </Row>
                    <TemplateCustomFieldInputs
                        fields={this.customFields}
                        values={this.state.custom}
                        errors={this.state.customErrors}
                        onChange={this.onCustomChange}
                    />
                    {canPrepareSignatureRequest ? (
                        <Form.Check
                            type="switch"
                            id="matter-report-signature-request"
                            label="Prepare signature request"
                            checked={this.state.signatureRequest}
                            disabled={working}
                            onChange={(e) => this.setState({ signatureRequest: e.target.checked })}
                        />
                    ) : null}
                    {working ? (
                        <div className="d-flex align-items-center text-muted mt-3">
                            <Spinner animation="border" size="sm" className="me-2" />
                            <span>{workingLabel}</span>
                        </div>
                    ) : null}
                </Modal>
            </>
        )
    }
}

export default ReportModal;
